import CompraFinalizada from './CompraFinalizada';
import { connect } from 'react-redux';

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CompraFinalizada);
